// ════════════════════════════════════════════════════════════════════════
//  Wortlisten für Übungscodes
//
//  VORLÄUFIG. Der Mechanismus steht, die Wortauswahl ist noch mit der Lehrkraft
//  abzustimmen (offener Punkt im Plan). Bis dahin sind das kuratierte Platzhalter,
//  die die Regeln unten schon einhalten.
//
//  Regeln, die nicht verhandelbar sind:
//
//  1. KEINE UMLAUTE, KEIN SZ. Der Code wird von Drittklässlern getippt, vorgelesen
//     und auf Kärtchen geschrieben. "kaefer" statt "käfer", "loewe" statt "löwe".
//  2. NUR POSITIVE ODER NEUTRALE EIGENSCHAFTSWÖRTER. Der Code hängt an einem Kind
//     und wird in der Klasse laut gesagt – "esel-faul-4711" darf nicht entstehen
//     können. Deshalb enthält die zweite Liste kein einzelnes abwertendes Wort.
//  3. Keine verwechselbaren Paare in derselben Liste.
//
//  64 × 64 × 10000 ≈ 41 Mio. Kombinationen. Gegen Durchprobieren schützt nicht die
//  Entropie allein, sondern das Rate-Limiting am Gateway.
// ════════════════════════════════════════════════════════════════════════

/** Erstes Wort: Tiere. */
export const ANIMALS: readonly string[] = [
  "esel",
  "igel",
  "hase",
  "biber",
  "dachs",
  "otter",
  "fuchs",
  "luchs",
  "marder",
  "wiesel",
  "eule",
  "spatz",
  "amsel",
  "meise",
  "reiher",
  "storch",
  "kranich",
  "schwan",
  "ente",
  "gans",
  "taube",
  "rabe",
  "elster",
  "specht",
  "kuckuck",
  "schnecke",
  "biene",
  "hummel",
  "ameise",
  "libelle",
  "grille",
  "falter",
  "kaefer",
  "frosch",
  "kroete",
  "molch",
  "eidechse",
  "forelle",
  "karpfen",
  "hecht",
  "krebs",
  "seestern",
  "delfin",
  "robbe",
  "walross",
  "pinguin",
  "kamel",
  "lama",
  "zebra",
  "giraffe",
  "elefant",
  "nashorn",
  "tiger",
  "loewe",
  "panda",
  "koala",
  "affe",
  "faultier",
  "kaenguru",
  "waschbaer",
  "murmeltier",
  "eichhorn",
  "maulwurf",
  "fledermaus",
];

/** Zweites Wort: Farben und positive Eigenschaften. */
export const TRAITS: readonly string[] = [
  "rot",
  "blau",
  "gruen",
  "gelb",
  "lila",
  "orange",
  "rosa",
  "braun",
  "grau",
  "weiss",
  "tuerkis",
  "golden",
  "silbern",
  "bunt",
  "hell",
  "dunkel",
  "flink",
  "munter",
  "froh",
  "klug",
  "mutig",
  "ruhig",
  "leise",
  "sanft",
  "stark",
  "schnell",
  "fleissig",
  "freundlich",
  "lustig",
  "neugierig",
  "tapfer",
  "treu",
  "wach",
  "warm",
  "weich",
  "wild",
  "zart",
  "frisch",
  "gluecklich",
  "geduldig",
  "hoeflich",
  "klar",
  "lieb",
  "offen",
  "pfiffig",
  "schlau",
  "sicher",
  "sonnig",
  "stolz",
  "tief",
  "wendig",
  "witzig",
  "zufrieden",
  "emsig",
  "heiter",
  "keck",
  "nett",
  "fein",
  "flott",
  "froehlich",
  "gross",
  "klein",
  "leicht",
  "rund",
];
